// SourceMentionsZone — German. 'Open', 'not collected' already live in common.de.ts and are not
// repeated here. Series labels render through `seriesLabel` (series.v1.ts), not this catalogue.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Named in sources': 'In Quellen genannt',
  'Name': 'Name',
  'Source': 'Quelle',
  'Category': 'Kategorie',
  'Document': 'Dokument',
  'Last modified': 'Zuletzt geändert',
  'Show': 'Zeigen',
  'hide': 'ausblenden',
  'Series': 'Reihen',
  'Period': 'Zeitraum',
  'Value': 'Wert',
}, 'SourceMentionsZone');
